import { useState } from "react";

import type { StepFields, ThinkingView } from "../../api/thinking";

type Submit = (fields: StepFields) => void;

export function TagStepView({
  view,
  busy,
  onSubmit,
}: {
  view: ThinkingView;
  busy: boolean;
  onSubmit: Submit;
}) {
  const [choice, setChoice] = useState("");
  const tag = view.tag;
  if (!tag) return null;
  return (
    <section>
      <h1>Question 2</h1>
      <blockquote className="context">{tag.context}</blockquote>
      <fieldset>
        <legend className="prompt">{tag.prompt}</legend>
        {tag.options.map((option) => (
          <label key={option.id} className="choice">
            <input
              type="radio"
              name="category"
              value={option.id}
              checked={choice === option.id}
              onChange={() => setChoice(option.id)}
            />
            {option.label}
          </label>
        ))}
      </fieldset>
      <button
        type="button"
        disabled={!choice || busy}
        onClick={() => onSubmit({ category_id: choice })}
      >
        Continue
      </button>
    </section>
  );
}

export function PickStepView({
  view,
  busy,
  onSubmit,
}: {
  view: ThinkingView;
  busy: boolean;
  onSubmit: Submit;
}) {
  const [statement, setStatement] = useState("");
  const [side, setSide] = useState<"agree" | "disagree" | "">("");
  const pick = view.pick;
  if (!pick) return null;
  return (
    <section>
      <h1>Question 3</h1>
      <fieldset>
        <legend className="prompt">{pick.prompt}</legend>
        {pick.statements.map((option) => (
          <label key={option.id} className="choice">
            <input
              type="radio"
              name="statement"
              value={option.id}
              checked={statement === option.id}
              onChange={() => setStatement(option.id)}
            />
            {option.label}
          </label>
        ))}
      </fieldset>
      <fieldset>
        <legend>Your side</legend>
        {(["agree", "disagree"] as const).map((value) => (
          <label key={value} className="choice">
            <input
              type="radio"
              name="side"
              value={value}
              checked={side === value}
              onChange={() => setSide(value)}
            />
            I {value}
          </label>
        ))}
      </fieldset>
      <p className="muted">The next part is timed.</p>
      <button
        type="button"
        disabled={!statement || !side || busy}
        onClick={() => side && onSubmit({ statement_id: statement, side })}
      >
        Continue
      </button>
    </section>
  );
}

export function CloseStepView({
  view,
  busy,
  onSubmit,
}: {
  view: ThinkingView;
  busy: boolean;
  onSubmit: Submit;
}) {
  const [city, setCity] = useState("");
  const [found, setFound] = useState("");
  const close = view.close;
  if (!close) return null;
  return (
    <section>
      <h1>Almost done</h1>
      <label htmlFor="city">{close.city_prompt}</label>
      <input
        id="city"
        maxLength={close.city_char_limit}
        value={city}
        onChange={(e) => setCity(e.target.value)}
        autoComplete="address-level2"
      />
      <label htmlFor="found">{close.found_prompt}</label>
      <textarea
        id="found"
        rows={3}
        maxLength={close.found_char_limit}
        value={found}
        onChange={(e) => setFound(e.target.value)}
      />
      <button
        type="button"
        disabled={!city.trim() || busy}
        onClick={() => onSubmit({ city, found_anything: found })}
      >
        Submit everything
      </button>
    </section>
  );
}
